<template>
  <el-dialog
    title="版权登记咨询"
    :visible.sync="dialogVisible"
    width="600px"
    :close-on-click-modal="false"
    :destroy-on-close="true"
     :before-close="close"
    custom-class="center_dialog"
  >
    <el-form :model="ruleForm" ref="ruleForm" label-width="0" class="copy_from">
      <el-row>
        <el-col :span="12">
          <el-form-item
            prop="contact"
            :rules="[{ required: true, message: '请输入姓名', trigger: 'blur' }]"
          >
            <div>姓名：</div>
            <el-input class="input-width260" v-model="ruleForm.contact" placeholder="请输入姓名"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            prop="class_one"
            :rules="[{ required: true, message: '请选择登记类别', trigger: 'blur' }]"
          >
            <div>登记类别：</div>
            <el-select class="input-width260" v-model="ruleForm.class_one">
              <el-option
                v-for="item in RegistrationCategory"
                :key="item.id"
                :label="item.name"
                :value="item.code"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            prop="class_two"
            :rules="[{ required: true, message: '请选择登记费用', trigger: 'blur' }]"
          >
            <div>登记费用：</div>
            <el-select class="input-width260" v-model="ruleForm.class_two">
              <el-option
                v-for="item in RegistrationFee"
                :key="item.id"
                :label="item.name"
                :value="item.code"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            prop="remark"
            :rules="[{ required: true, message: '请输入单位/学校', trigger: 'blur' }]"
          >
            <div>单位/学校：</div>
            <el-input class="input-width260" v-model="ruleForm.remark" placeholder="请输入单位/学校"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            prop="synopsis"
            :rules="[
      { required: true, message: '请输入邮箱地址', trigger: 'blur' },
      { type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change'] }
    ]"
          >
            <div>邮箱：</div>
            <el-input class="input-width260" v-model="ruleForm.synopsis" placeholder="请输入邮箱"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            prop="contact_phone"
            :rules="[{ required: true, message: '请输入手机号', trigger: 'blur' },{ min: 11, max: 11, message: '请输入11位手机号码', trigger: 'blur' }]"
          >
            <div>手机号：</div>
            <el-input class="input-width260" v-model="ruleForm.contact_phone" placeholder="请输入手机号"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="close">取 消</el-button>
      <el-button type="primary" @click="submitForm('ruleForm')">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  props: {
    dialogVisible: {
      type: Boolean
    },
  },
  data(){
      return {
        ruleForm: {},
        RegistrationCategory: [],
        RegistrationFee: []
      }
  },
   computed: {
    info() {
      return this.$store.state.info;
    }
  },
  created(){
    this.getDictionaries("RegistrationCategory", "RegistrationCategory"); //登记类别
    this.getDictionaries("RegistrationFee", "RegistrationFee"); //登记费用
  },
  methods:{
       /** 获取字典数据 */
    getDictionaries(typeCode, key) {
      let params = {
        typeCode: typeCode,
        pageNo: 0,
        pageSize: 999
      };
      this.api.getDictionaries(params).then(res => {
        this[key] = res.obj.list;
      });
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.schoolApply();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
   
    // 添加报名
    schoolApply() {
      let code = (this.info && this.info.code) || "";
      let obj = Object.assign({}, this.ruleForm, {
        code: code,
        type: "EntityTypeCopyright"
      });
      this.api.schoolApply(obj).then(res => {
        if (res.error.err_code !== 0) return;
        this.$message.success("登记成功");
        this.close();
      });
    },
     close() {
      this.$emit("close", {
        name: "copyright_registration",
        dialogVisible: false
      });
    }
  }
};
</script>

<style lang="scss" scoped>
</style>